// ─── DESTINATIONS DATA ────────────────────────────────────────────────────────
// Each destination has: id, name, visaCount, img, tag (visa type), fee,
// originalFee, popularity, region

export const destinations = [
  { id:1,  code:"AE", name:"United Arab Emirates", visaCount:"53K+", img:"https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&q=80", tag:"eVisa", fee:"₹999", originalFee:"₹1,499", popularity:"M.V", region:"Middle East" },
  { id:2,  code:"TH", name:"Thailand", visaCount:"32K+", img:"https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=600&q=80", tag:"eVisa", fee:"₹699", originalFee:"₹999", popularity:"T.P", region:"Asia" },
  { id:3,  code:"CH", name:"Switzerland", visaCount:"30K+", img:"https://images.unsplash.com/photo-1527668752968-14dc70a27c95?w=600&q=80", tag:"Sticker", fee:"₹3,999", originalFee:"₹4,999", popularity:"M.T", region:"Europe" },
  { id:4,  code:"VN", name:"Vietnam", visaCount:"27K+", img:"https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=600&q=80", tag:"eVisa", fee:"₹1,299", originalFee:"₹1,799", popularity:"B.D", region:"Asia" },
  { id:5,  code:"ID", name:"Indonesia", visaCount:"16K+", img:"https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=600&q=80", tag:"eVisa", fee:"₹599", originalFee:"₹799", popularity:"T.P", region:"Asia" },
  { id:6,  code:"MV", name:"Maldives", visaCount:"17K+", img:"https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=600&q=80", tag:"Free", fee:"Free", originalFee:null, popularity:"M.L", region:"Asia" },
  { id:7,  code:"US", name:"United States", visaCount:"25K+", img:"https://images.unsplash.com/photo-1485738422979-f5c462d49f74?w=600&q=80", tag:"Sticker", fee:"₹9,999", originalFee:"₹12,999", popularity:"M.V", region:"Americas" },
  { id:8,  code:"HK", name:"Hong Kong", visaCount:"19K+", img:"https://images.unsplash.com/photo-1536599018102-9f803c140fc1?w=600&q=80", tag:"eVisa", fee:"₹899", originalFee:"₹1,299", popularity:"M.T", region:"Asia" },
  { id:9,  code:"EG", name:"Egypt", visaCount:"24K+", img:"https://images.unsplash.com/photo-1568322445389-f64ac2515020?w=600&q=80", tag:"eVisa", fee:"₹1,999", originalFee:"₹2,499", popularity:"B.D", region:"Africa" },
  { id:10, code:"MY", name:"Malaysia", visaCount:"37K+", img:"https://images.unsplash.com/photo-1555921015-5532091f6026?w=600&q=80", tag:"eVisa", fee:"₹399", originalFee:"₹599", popularity:"M.V", region:"Asia" },
  { id:11, code:"SG", name:"Singapore", visaCount:"22K+", img:"https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=600&q=80", tag:"eVisa", fee:"₹2,299", originalFee:"₹2,999", popularity:"T.P", region:"Asia" },
  { id:12, code:"TR", name:"Turkey", visaCount:"21K+", img:"https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=600&q=80", tag:"eVisa", fee:"₹1,399", originalFee:"₹1,899", popularity:"M.T", region:"Middle East" },
  { id:13, code:"FR", name:"France", visaCount:"18K+", img:"https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600&q=80", tag:"Sticker", fee:"₹4,999", originalFee:"₹6,499", popularity:"M.L", region:"Europe" },
  { id:14, code:"JP", name:"Japan", visaCount:"29K+", img:"https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=600&q=80", tag:"Sticker", fee:"₹2,699", originalFee:"₹3,499", popularity:"M.V", region:"Asia" },
  { id:15, code:"CA", name:"Canada", visaCount:"14K+", img:"https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=600&q=80", tag:"eTA", fee:"₹3,199", originalFee:"₹4,199", popularity:"T.P", region:"Americas" },
  { id:16, code:"AU", name:"Australia", visaCount:"20K+", img:"https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=600&q=80", tag:"eVisa", fee:"₹4,299", originalFee:"₹5,499", popularity:"M.T", region:"Oceania" },
  { id:17, code:"NZ", name:"New Zealand", visaCount:"11K+", img:"https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=600&q=80", tag:"eTA", fee:"₹2,999", originalFee:"₹3,999", popularity:"B.D", region:"Oceania" },
  { id:18, code:"DE", name:"Germany", visaCount:"15K+", img:"https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=600&q=80", tag:"Sticker", fee:"₹5,599", originalFee:"₹7,299", popularity:"M.T", region:"Europe" },
  { id:19, code:"ES", name:"Spain", visaCount:"13K+", img:"https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=600&q=80", tag:"Sticker", fee:"₹5,299", originalFee:"₹6,799", popularity:"M.L", region:"Europe" },
  { id:20, code:"IT", name:"Italy", visaCount:"16K+", img:"https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?w=600&q=80", tag:"Sticker", fee:"₹5,499", originalFee:"₹6,999", popularity:"M.T", region:"Europe" },
];

// ─── REGION OPTIONS (for dropdown) ───────────────────────────────────────────
export const REGIONS = [
  { value: "All",         label: " All Regions"  },
  { value: "Asia",        label: "Asia"          },
  { value: "Europe",      label: "Europe"       },
  { value: "Middle East", label: " Middle East"   },
  { value: "Americas",    label: "Americas"      },
  { value: "Africa",      label: " Africa"        },
  { value: "Oceania",     label: " Oceania"       },
];

// ─── VISA TYPE OPTIONS (for dropdown) ────────────────────────────────────────
export const VISA_TYPES = [
  { value: "All",     label: "All Visa Types" },
  { value: "eVisa",    label: "eVisa"          },
  { value: "Sticker",  label: "Sticker"        },
  { value: "eTA",      label: "eTA"            },
  { value: "Free",     label: "Visa Free"      },
];

const DESTINATION_IMAGE_BY_CODE = {
  AE: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=1200&q=80",
  TH: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=1200&q=80",
  CH: "https://images.unsplash.com/photo-1527668752968-14dc70a27c95?w=1200&q=80",
  VN: "https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=1200&q=80",
  ID: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1200&q=80",
  MV: "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=1200&q=80",
  US: "https://images.unsplash.com/photo-1485738422979-f5c462d49f74?w=1200&q=80",
  HK: "https://images.unsplash.com/photo-1536599018102-9f803c140fc1?w=1200&q=80",
  EG: "https://images.unsplash.com/photo-1568322445389-f64ac2515020?w=1200&q=80",
  MY: "https://images.unsplash.com/photo-1555921015-5532091f6026?w=1200&q=80",
  SG: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=1200&q=80",
  TR: "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=1200&q=80",
  FR: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=1200&q=80",
  JP: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=1200&q=80",
  CA: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=1200&q=80",
  AU: "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=1200&q=80",
  NZ: "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=1200&q=80",
  DE: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=1200&q=80",
  ES: "https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=1200&q=80",
  IT: "https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?w=1200&q=80",
};

const formatInr = (n) => (n > 0 ? `\u20b9${n.toLocaleString("en-IN")}` : "Check Price");

const VISA_TAG_NORMALIZE = {
  "E-Visa (Paperless)": "eVisa",
  "TR Visa (E-Visa)": "eVisa",
  "E-Visa (Single/Multiple)": "eVisa",
  "VOA / E-Visa on Arrival": "eVisa",
  "Visa on Arrival": "Free",
  "eNTRI": "eVisa",
  "SVP Tourist Visa": "eVisa",
  "E-Visa": "eVisa",
  "HKSAR Pre-Arrival Reg": "eVisa",
  "Schengen Visa (Type C)": "Sticker",
  "B1/B2 Tourist Visa": "Sticker",
  "Tourist Visa": "Sticker",
  "Temporary Resident Visa": "eTA",
  "Subclass 600 Tourist": "eVisa",
  "Visitor Visa": "eTA",
};

const POPULARITY_BY_CODE = {
  AE: "M.V", TH: "T.P", CH: "M.T", VN: "B.D",
  ID: "T.P", MV: "M.L", US: "M.V", HK: "M.T",
  EG: "B.D", MY: "M.V", SG: "T.P", TR: "M.T",
  FR: "M.L", JP: "M.V", CA: "T.P", AU: "M.T",
  NZ: "B.D", DE: "M.T", ES: "M.L", IT: "M.T",
};

function normalizeTag(raw) {
  if (!raw) return null;
  return VISA_TAG_NORMALIZE[raw] || raw;
}

function normalizeDestinationCountries(apiCountries, visaProducts = []) {
  if (!Array.isArray(apiCountries) || apiCountries.length === 0) return destinations;

  const productByCode = new Map();
  for (const p of visaProducts) {
    const code = String(p?.country_code || "").toUpperCase();
    if (!code) continue;
    const total = Number(p?.gov_fee || 0) + Number(p?.svc_fee || 0);
    const prev = productByCode.get(code);
    if (!prev || total < prev.total) {
      productByCode.set(code, {
        total,
        original: Number(p?.svc_fee_orig || 0) > 0 ? Number(p?.gov_fee || 0) + Number(p?.svc_fee_orig || 0) : 0,
        tag: normalizeTag(p?.visa_type_label) || "Visa",
      });
    }
  }

  return apiCountries.map((row, idx) => {
    const code = String(row?.code || "").toUpperCase();
    const name = String(row?.name || "").trim();
    const priced = productByCode.get(code);
    const img = row?.img || DESTINATION_IMAGE_BY_CODE[code] || "";
    const fee = row?.fee || formatInr(priced?.total || 0);
    const originalFee = row?.originalFee ?? (priced?.original ? formatInr(priced.original) : null);

    return {
      id: row?.id ?? idx + 1,
      code,
      name: name || "Destination",
      visaCount: row?.visaCount || "Popular",
      img,
      tag: normalizeTag(row?.tag) || priced?.tag || "Visa",
      fee,
      originalFee,
      popularity: POPULARITY_BY_CODE[code] || row?.popularity || "M.V",
      region: row?.region || "All",
    };
  });
}

export { normalizeDestinationCountries }; // keep util for reuse
